import { observable } from "@legendapp/state";
import type { Session } from "@/apis/clients/sessionClient";

interface AuthState {
  /**
   * Whether the backend reports a live session.
   *
   * This is a cache of a server fact, not a client decision. It is set from
   * the answer to GET /api/auth/session and cleared when any API call comes
   * back 401. Setting it optimistically would only change what this tab
   * renders — every request is still gated server-side by a cookie JavaScript
   * cannot read.
   */
  isAuthenticated: boolean;
  /** Who the backend says is signed in, or null when nobody is. */
  session: Session | null;
  /** False once the first session check has settled, either way. */
  isResolving: boolean;
}

const defaultValues: AuthState = {
  isAuthenticated: false,
  isResolving: true,
  session: null,
};

export const AuthStore$ = observable(defaultValues);

/** Records the backend's answer. Passing null marks the user signed out. */
export const setSession = (session: Session | null): void => {
  AuthStore$.session.set(session);
  AuthStore$.isAuthenticated.set(session !== null);
  AuthStore$.isResolving.set(false);
};
